import product1 from "./images/product1.jpg"
import product2 from "./images/product2.jpg"
import product3 from "./images/product3.jpg"
import product4 from "./images/product4.jpg"
import product5 from "./images/product5.jpg"
import product6 from "./images/product6.jpg"
import product7 from "./images/product7.jpg"
import product8 from "./images/product8.jpg"
import product9 from "./images/product9.jpg"
import product10 from "./images/product10.jpg"
import product11 from "./images/product11.jpg"
import product12 from "./images/product12.jpg"
import product13 from "./images/product13.jpg"
import product14 from "./images/product14.jpg"
import product15 from "./images/product15.jpg"
import product16 from "./images/product16.jpg"
import product17 from "./images/product17.jpg"
import product18 from "./images/product18.jpg"
import product19 from "./images/product19.jpg"
import product20 from "./images/product20.jpg"
import product21 from "./images/product21.jpg"
import product22 from "./images/product22.jpg"
import product23 from "./images/product23.jpg"
import product24 from "./images/product24.jpg"
import product25 from "./images/product25.jpg"
import product26 from "./images/product26.jpg"
import product27 from "./images/product27.jpg"
import product28 from "./images/product28.jpg"
import product29 from "./images/product29.jpg"
import product30 from "./images/product30.jpg"
import product31 from "./images/product31.jpg"
import product32 from "./images/product32.jpg"
import product33 from "./images/product33.jpg"
import product34 from "./images/product34.jpg"
import product36 from "./images/product36.jpg"





export const products = [
    {
        id: 1 ,
        title:"16 piezas (2 variedades)",
        category:"Sushi" ,
        image: product1,
        price:23000,
        description:[
        `💥SPF roll.......(salmon, palta y finladia)` ,

        `💥EBI roll.........(langostinos, finlandia y verdeo)`,
        
        `💥SKIN roll........(salmon con piel, finlandia y verdeo)`,
        
        `💥VEGGIE roll.....(palta, pepino, morron ahumado y finlandia)`,
        
        `💥HOSOMAKI.......(salmon con alga nori por fuera)`,
        
        `💥CHEESE roll........(salmon crispy y palta)`,
        
        `💥ROSHI Roll........(langostinos crispy, finlandia y ciboulette`,
        
        `💥LPF roll............(Langostinos, palta y finlandia)`,
        
        `💥Cheese Ebi roll........(langostinos y palta vestido con queso y crocante)`,
        
        `💥NIGUIRI...........de salmon o skin(salmon cn piel) 4 unidades`,

        `💥Caribe ..........salmon,palta finlandia y mango`,
        
        `💥Sake roll.....salmon,finlandia y ciboulette`,

        `💥California.............kanikama,palta`,

        `💥Tamago.............salmon,finlandia y ciboulette `,
        
        `📌Este combinado incluye: 2 variedades, wasabi, palitos chinos y salsa de soja o teriyaki.`,
        `⠀📌 1 variedad de salmon `]
    },
    
    {
        id: 2,
        title:"24 piezas (3 variedades)",
        category:"Sushi" ,
        image:product2,
        price:32000,
        description:[
            `💥SPF roll.......(salmon, palta y finladia)` ,
    
            `💥EBI roll.........(langostinos, finlandia y verdeo)`,
            
            `💥SKIN roll........(salmon con piel, finlandia y verdeo)`,
            
            `💥VEGGIE roll.....(palta, pepino, morron ahumado y finlandia)`,
            
            `💥HOSOMAKI.......(salmon con alga nori por fuera)`,
            
            `💥CHEESE roll........(salmon crispy y palta)`,
            
            `💥ROSHI Roll........(langostinos crispy, finlandia y ciboulette`,
            
            `💥LPF roll............(Langostinos, palta y finlandia)`,
            
            `💥Cheese Ebi roll........(langostinos y palta vestido con queso y crocante)`,
            
            `💥NIGUIRI...........de salmon o skin(salmon cn piel) 4 unidades`,

            `💥Caribe ..........salmon,palta finlandia y mango`,

            `💥Sake roll.....salmon,finlandia y ciboulette`,
            
            `💥California.............kanikama,palta`,

            `💥Tamago.............salmon,finlandia y ciboulette `,
            
            `📌Este combinado incluye: 3 variedades, wasabi, palitos chinos y salsa de soja o teriyaki.`,
            `⠀📌 1 variedad maximo de salmon `]
    },
   
    {
        id: 3,
        title:"32 piezas (4 variedades)",
        category:"Sushi" ,
        image:product3,
        price:42000,
        description:[
            `💥SPF roll.......(salmon, palta y finladia)` ,
    
            `💥EBI roll.........(langostinos, finlandia y verdeo)`,
            
            `💥SKIN roll........(salmon con piel, finlandia y verdeo)`,
            
            `💥VEGGIE roll.....(palta, pepino, morron ahumado y finlandia)`,
            
            `💥HOSOMAKI.......(salmon con alga nori por fuera)`,
            
            `💥CHEESE roll........(salmon crispy y palta)`,
            
            `💥ROSHI Roll........(langostinos crispy, finlandia y ciboulette`,
            
            `💥LPF roll............(Langostinos, palta y finlandia)`,
            
            `💥Cheese Ebi roll........(langostinos y palta vestido con queso y crocante)`,
            
            `💥NIGUIRI...........de salmon o skin(salmon cn piel) 4 unidades`,

            `💥California.............kanikama,palta`,

            `💥Tamago.............salmon,finlandia y ciboulette `,
            
            `💥Caribe ..........salmon,palta finlandia y mango`,
            
            `💥Sake roll.....salmon,finlandia y ciboulette`,
            
            `📌Este combinado incluye: 4 variedades, wasabi, palitos chinos y salsa de soja o teriyaki.`,
            `⠀📌 2 variedades maximo de salmon `]
    },
    {
        id: 4,
        title:"40 piezas (5 variedades)",
        category:"Sushi" ,
        image:product4,
        price:52000,
        description:[
            `💥SPF roll.......(salmon, palta y finladia)` ,
    
            `💥EBI roll.........(langostinos, finlandia y verdeo)`,
            
            `💥SKIN roll........(salmon con piel, finlandia y verdeo)`,
            
            `💥VEGGIE roll.....(palta, pepino, morron ahumado y finlandia)`,
            
            `💥HOSOMAKI.......(salmon con alga nori por fuera)`,
            
            `💥CHEESE roll........(salmon crispy y palta)`,
            
            `💥ROSHI Roll........(langostinos crispy, finlandia y ciboulette`,
            
            `💥LPF roll............(Langostinos, palta y finlandia)`,
            
            `💥Cheese Ebi roll........(langostinos y palta vestido con queso y crocante)`,
            
            `💥NIGUIRI...........de salmon o skin(salmon cn piel) 4 unidades`,
            
            `💥California.............kanikama,palta`,
            
            `💥Tamago.............salmon,finlandia y ciboulette `,
            
            `💥Caribe ..........salmon,palta finlandia y mango`,
            
            `💥Sake roll.....salmon,finlandia y ciboulette`,
            
            `📌Este combinado incluye: 5 variedades, wasabi, palitos chinos y salsa de soja o teriyaki.`,
            `⠀📌 2 variedades maximo de salmon `]
    },
    {
        id: 5,
        title:"48 piezas (6 variedades)",
        category:"Sushi" ,
        image: product5,
        price:62000,
        description:[
            `💥SPF roll.......(salmon, palta y finladia)` ,
    
            `💥EBI roll.........(langostinos, finlandia y verdeo)`,
            
            `💥SKIN roll........(salmon con piel, finlandia y verdeo)`,
            
            `💥VEGGIE roll.....(palta, pepino, morron ahumado y finlandia)`,
            
            `💥HOSOMAKI.......(salmon con alga nori por fuera)`,
            
            `💥CHEESE roll........(salmon crispy y palta)`,
            
            `💥ROSHI Roll........(langostinos crispy, finlandia y ciboulette`,
            
            `💥LPF roll............(Langostinos, palta y finlandia)`,
            
            `💥Cheese Ebi roll........(langostinos y palta vestido con queso y crocante)`,
            
            `💥NIGUIRI...........de salmon o skin(salmon cn piel) 4 unidades`,
            
            `💥California.............kanikama,palta`,
            
            `💥Tamago.............salmon,finlandia y ciboulette `,
            
            `💥Caribe ..........salmon,palta finlandia y mango`,
            
            `💥Sake roll.....salmon,finlandia y ciboulette`,
            
            `📌Este combinado incluye: 6 variedades, wasabi, palitos chinos y salsa de soja o teriyaki.`,
            `⠀📌 3 variedades maximo de salmon `]
    },
    {
        id: 6,
        title:"56 piezas (7 variedades)",
        category:"Sushi" ,
        image:product6,
        price:74000,
        description:[
            `💥SPF roll.......(salmon, palta y finladia)` ,
    
            `💥EBI roll.........(langostinos, finlandia y verdeo)`,
            
            `💥SKIN roll........(salmon con piel, finlandia y verdeo)`,
            
            `💥VEGGIE roll.....(palta, pepino, morron ahumado y finlandia)`,
            
            `💥HOSOMAKI.......(salmon con alga nori por fuera)`,
            
            `💥CHEESE roll........(salmon crispy y palta)`,
            
            `💥ROSHI Roll........(langostinos crispy, finlandia y ciboulette`,
            
            `💥LPF roll............(Langostinos, palta y finlandia)`,
            
            `💥Cheese Ebi roll........(langostinos y palta vestido con queso y crocante)`,
            
            `💥NIGUIRI...........de salmon o skin(salmon cn piel) 4 unidades`,
            
            `💥California.............kanikama,palta`,
            
            `💥Tamago.............salmon,finlandia y ciboulette `,
            
            `💥Caribe ..........salmon,palta finlandia y mango`,
            
            `💥Sake roll.....salmon,finlandia y ciboulette`,
            
            `📌Este combinado incluye: 7 variedades, wasabi, palitos chinos y salsa de soja o teriyaki.`,
            `⠀📌 3 variedades maximo de salmon `]
    },
    {
        id: 7,
        title:"64 piezas (8 variedades)",
        category:"Sushi" ,
        image:product7,
        price:86000,
        description:[
            `💥SPF roll.......(salmon, palta y finladia)` ,
    
            `💥EBI roll.........(langostinos, finlandia y verdeo)`,
            
            `💥SKIN roll........(salmon con piel, finlandia y verdeo)`,
            
            `💥VEGGIE roll.....(palta, pepino, morron ahumado y finlandia)`,
            
            `💥HOSOMAKI.......(salmon con alga nori por fuera)`,
            
            `💥CHEESE roll........(salmon crispy y palta)`,
            
            `💥ROSHI Roll........(langostinos crispy, finlandia y ciboulette`,
            
            `💥LPF roll............(Langostinos, palta y finlandia)`,
            
            `💥Cheese Ebi roll........(langostinos y palta vestido con queso y crocante)`,
            
            `💥NIGUIRI...........de salmon o skin(salmon cn piel) 4 unidades`,
            
            `💥California.............kanikama,palta`,
            
            `💥Tamago.............salmon,finlandia y ciboulette `,
            
            `💥Caribe ..........salmon,palta finlandia y mango`,
            
            `💥Sake roll.....salmon,finlandia y ciboulette`,
            
            `📌Este combinado incluye: 8 variedades, wasabi, palitos chinos y salsa de soja o teriyaki.`,
            `⠀📌 4 variedades maximo de salmon `]
    },
    {
        id: 8,
        title:"72 piezas (9 variedades)",
        category:"Sushi" ,
        image:product8,
        price:98000,
        description:[
            `💥SPF roll.......(salmon, palta y finladia)` ,
    
            `💥EBI roll.........(langostinos, finlandia y verdeo)`,
            
            `💥SKIN roll........(salmon con piel, finlandia y verdeo)`,
            
            `💥VEGGIE roll.....(palta, pepino, morron ahumado y finlandia)`,
            
            `💥HOSOMAKI.......(salmon con alga nori por fuera)`,
            
            `💥CHEESE roll........(salmon crispy y palta)`,
            
            `💥ROSHI Roll........(langostinos crispy, finlandia y ciboulette`,
            
            `💥LPF roll............(Langostinos, palta y finlandia)`,
            
            `💥Cheese Ebi roll........(langostinos y palta vestido con queso y crocante)`,
            
            `💥NIGUIRI...........de salmon o skin(salmon cn piel) 4 unidades`,
            
            `💥California.............kanikama,palta`,
            
            `💥Tamago.............salmon,finlandia y ciboulette `,
            
            `💥Caribe ..........salmon,palta finlandia y mango`,
            
            `💥Sake roll.....salmon,finlandia y ciboulette`,
            
            `📌Este combinado incluye: 9 variedades, wasabi, palitos chinos y salsa de soja o teriyaki.`,
            `⠀📌 4 variedades maximo de salmon `]
    },
    {
        id: 9,
        title:"80 piezas (10 variedades)",
        category:"Sushi" ,
        image:product9,
        price:110000,
        description:[
            `💥SPF roll.......(salmon, palta y finladia)` ,
    
            `💥EBI roll.........(langostinos, finlandia y verdeo)`,
            
            `💥SKIN roll........(salmon con piel, finlandia y verdeo)`,
            
            `💥VEGGIE roll.....(palta, pepino, morron ahumado y finlandia)`,
            
            `💥HOSOMAKI.......(salmon con alga nori por fuera)`,
            
            `💥CHEESE roll........(salmon crispy y palta)`,
            
            `💥ROSHI Roll........(langostinos crispy, finlandia y ciboulette`,
            
            `💥LPF roll............(Langostinos, palta y finlandia)`,
            
            `💥Cheese Ebi roll........(langostinos y palta vestido con queso y crocante)`,
            
            `💥NIGUIRI...........de salmon o skin(salmon cn piel) 4 unidades`,
            
            `💥California.............kanikama,palta`,
            
            `💥Tamago.............salmon,finlandia y ciboulette `,
            
            `💥Caribe ..........salmon,palta finlandia y mango`,
            
            `💥Sake roll.....salmon,finlandia y ciboulette`,
            
            `📌Este combinado incluye: 10 variedades, wasabi, palitos chinos y salsa de soja o teriyaki.`,
            `⠀📌 5 variedades maximo de salmon `
        ]
    },
    {
        id: 30,
        title:"16 piezas de salmon",
        category:"Sushi" ,
        image:product30,
        price:33000,
        description:[
            `💥 SPF`,

        ` 💥Sake roll` ,
        
        ` 💥Niguiri` ,
        
        ` 💥Tamago` ,
        
        ` 💥Cheese roll` ,
        
        ` 💥Skin roll` ,
        
        ` 💥Hosomaki`,
        
        ` 💥Tamago ebi.`,

        ` 💥Caribe.`,
        
        ],
    },
    {
        id: 31,
        title:"24 piezas de salmon",
        category:"Sushi" ,
        image:product31,
        price:49000,
        description:[
            `💥 SPF`,

        ` 💥Sake roll` ,
        
        ` 💥Niguiri` ,
        
        ` 💥Tamago` ,
        
        ` 💥Cheese roll` ,
        
        ` 💥Skin roll` ,
        
        ` 💥Hosomaki`,

        ` 💥Tamago ebi.`,

        ` 💥Caribe.`,
        
        ],
    },
    {
        id: 32,
        title:"32 piezas de salmon",
        category:"Sushi" ,
        image:product32,
        price:65000,
        description:[
            `💥 SPF`,

        ` 💥Sake roll` ,
        
        ` 💥Niguiri` ,
        
        ` 💥Tamago` ,
        
        ` 💥Cheese roll` ,
        
        ` 💥Skin roll` ,
        
        ` 💥Hosomaki`,

        ` 💥Tamago ebi.`,

        ` 💥Caribe.`,
        ],
    },
    {
        id: 33,
        title:"40 piezas de salmon",
        category:"Sushi" ,
        image:product33,
        price:83000,
        description:[
            `💥 SPF,

        💥Sake roll,
        
        💥Niguiri,
        
        💥Tamago,
        
        💥Cheese roll,
        
        💥Skin roll,
        
        💥Hosomaki,

        💥Tamago ebi,

        💥Caribe.`
        ],
    },
    {
        id: 10,
        title:"Arroz chaufa",
        category:"Comida peruana" ,
        image:product10,
        price:13000,
        description:[`Salteado de arroz tipico peruano. Contiene pollo, salchicha, pimiento rojo, verdeo y jengibre, bañado en salsa de soja. Acompañado de un omelette`],
    },
    {
        id: 11,
        title:"Ceviche",
        category:"Comida peruana" ,
        image:product11,
        price:11500,
        description:[`Con pesca blanca.`],
    },
    {
        id: 12,
        title:"Ceviche SHITAKE",
        category:"Comida peruana" ,
        image:product12,
        price:17000,
        description:[`Ceviche de salmon y langostinos frescos con batata, choclo, maiz cancha y cilantro.`],
    },
    {
        id: 13,
        title:"Ceviche mixto",
        category:"Comida peruana" ,
        image:product13,
        price:14000,
        description:[`Pesca blanca y langostinos.`],
    },
    {
        id: 14,
        title:"Chow fan",
        category:"Comida oriental" ,
        image:product14,
        price:15000,
        description:[`Chow fan de langostinos con arroz koshihikari y vegetales al wok.`],
    },
    {
        id: 15,
        title:"Combinado sashimi ( +32 PIEZAS )",
        category:"" ,
        image:product15,
        price:29000,
        description:[`Son 32 piezas: 4 variedades(puede ser un roll caliente)

        Mas 8 sashimi de salmon en forma de rosa.
        
        Contiene wasabi, palitos chinos y salsa de soja o teriyaky`],
    },
    {
        id: 16,
        title:"Combinado veggie",
        category:"" ,
        image:product16,
        price:16000,
        description:[`Maki con palta, morron ahumado, pepino y finlandia. vestido con ciboulette y semillas tostadas.

        Tamago(huevo) con tomate sin piel, palta y finlandia.
        
        El combinado incluye palitos chinos, wasabi y salsa de soja o teriyaki.`],
    },
    {
        id: 17,
        title:"Empanadas chinas",
        category:"Entradas" ,
        image:product17,
        price:2200,
        description:[`Empanada china de carne y/o verdura.

        Por Unidad.`],
    },
    {
        id: 18,
        title:"Empanadas chinas x4",
        category:"Entradas" ,
        image:product18,
        price:8000,
        description:[`Empanadas chinas de carne y/o verdura.`],
    },
    {
        id: 19,
        title:"Empanadas chinas x6",
        category:"Entradas" ,
        image:product19,
        price:12000,
        description:[`Empanadas chinas de carne y/o verdura.`],
    },
    {
        id: 38,
        title:"Empanadas chinas x12",
        category:"Entradas" ,
        image:product19,
        price:24000,
        description:[`Empanadas chinas de carne y/o verdura.`],
    },
    {
        id: 20,
        title:"Gohan sake (600gr)",
        category:"Comida oriental" ,
        image:product20,
        price:20000,
        description:[`Salmon (crudo)

        Kanikama
        
        Tamago/huevo
        
        Tomate
        
        Verdeo
        
        Palta
        
        Finlandia
        
        Arroz
        
        Sesamo tostado`,]
    },
    {
        id: 21,
        title:"Gohan completo",
        category:"Comida oriental" ,
        image:product21,
        price:18000,
        description:[`Langostinos

        Salmón
        
        Kanikama
        
        Pollo teriyaki
        
        Palta
        
        Finlandia
        
        Arroz de sushi
        
        Verdeo`],
    },
    {
        id: 22,
        title:"Gohan ebi (600gr)",
        category:"Comida oriental" ,
        image:product22,
        price:14000,
        description:[`Langostinos

        Kanikama
        
        Choclo
        
        Tomate
        
        Palta
        
        Finlandia
        
        Arroz`],
    },
    {
        id: 23,
        title:"Gohan limeño",
        category:"Comida fusion" ,
        image:product23,
        price:18000,
        description:[`Langostinos crispy, salmon crocante, crema a la huancaina, cilantro, finlandia palta y maiz cancha.`],
    },
    {
        id: 24,
        title:"Gohan tory (600gr)",
        category:"Comida oriental" ,
        image:product24,
        price:17000,
        description:[`Langostino crispy

        Pollo teriyaki
        
        Kanikama
        
        Verdeo
        
        Palta
        
        Finlandia
        
        Arroz
        
        Sesamo tostado`,]
    },
    {
        id: 25,
        title:"Langostinos crispy",
        category:"" ,
        image:product25,
        price:20000,
        description:[`300 gr |Langostinos rebozados en panko para 2 personas`],
    },
    {
        id: 26,
        title:"Rabas",
        category:"Entradas" ,
        image:product26,
        price:17000,
        description:[`Entrada para 2 personas`],
    },
    {
        id: 27,
        title:"Ramen shoyu",
        category:"Comida oriental" ,
        image:product27,
        price:7000,
        description:[`Caldo de res con miso y fideos frescos con choclo, verdeo y naruto.`],
    },
    {
        id: 28,
        title:"Ramen shiitake",
        category:"Comida oriental" ,
        image:product28,
        price:8500,
        description:[`Caldo de res con miso, fideos frescos, hongos shiitake, solomillo de cerdo con base wok, choclo, verdeo y naruto.`],
    },
    {
        id: 29,
        title:"Roll Calientes",
        category:"Sushi" ,
        image:product36,
        price:14000,
        description:[`Hot veggie

        Hot phila
        
        Hot skin
        
        Hot ebi`],
    },
    {
        id: 36,
        title:"Roll caliente de salmon ",
        category:"Sushi" ,
        image:product29,
        price:15000,
        description:[`Hot veggie

        Hot phila
        
        Hot skin
        
        Hot ebi`],
    },
    {
        id: 37,
        title:"gyozas",
        category:"Entradas" ,
        image:product34,
        price:1800,
        description:[`Gyozas de cerdo acompañada con salsa especial`],
    },
    {
        id: 34,
        title:"gyozas x4",
        category:"Entradas" ,
        image:product34,
        price:6700,
        description:[`Gyozas de cerdo acompañada con salsa especial`],
    },
    {
        id: 35,
        title:"gyozas x6",
        category:"Entradas" ,
        image:product34,
        price:10000,
        description:[`Gyozas de cerdo acompañada con salsa especial`],
    },
   
    
]